<template>
  <div>
    <!--<v-alert type="info" prominent class="text-left">
      Dear customers,
      <br><br>
      Due to electrical works taking place near our premises, our internal website will be down from approximately 6am to 6pm on Sunday, February 9th, 2020. During this time you will not be able to place orders or view your accounts. You will however, still be able to view our gallery.
      <br><br>
      We apologise for any inconvenience this may cause.
    </v-alert>
    -->
    <v-card>
      <!-- <v-toolbar color="secondary" class="primary--text" dark flat> -->
      <v-toolbar color="primary" class="secondary--text" dark flat>
        <v-toolbar-title class="headline">Login</v-toolbar-title>
        <!-- <v-spacer />
        <v-btn @click='$emit("signUp")' color="green">Or Sign Up</v-btn> -->
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validForm" ref="loginForm">
          <v-text-field
            @keyup.enter="login()"
            v-model="username"
            ref="username"
            label="Username"
            prepend-icon="mdi-account"
            type="text"
            :rules="usernameRules"
            color="secondary"
            required
            clearable
          />
          <v-text-field
            @keyup.enter="login()"
            v-model="password"
            id="password"
            label="Password"
            prepend-icon="mdi-lock"
            type="password"
            :rules="passwordRules"
            color="secondary"
            required
            clearable
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="text-center">
          <!--          <ResetPasswordLinkModal @submit="resetPassword" :username="username" />-->
        </div>
        <v-spacer />
        <!--        <Spinner :active='isLoading' :full-page='fullPage' />-->
        <!--        <v-btn @click="$refs.loginForm.reset()" color="red" outlined>Clear</v-btn>-->
        <v-btn @click="login()" :disabled="!validForm || isLoading" :loading="isLoading" color="secondary" class="primary--text">Login</v-btn>
      </v-card-actions>
    </v-card>
    <cookie-helper v-if="triggerCookieHelper" @cookiesDone="blackMagic" cookie-name="nettex-www" />
    <v-alert
      v-model="alertState"
      :color="isError ? 'red' : 'green'"
      class="mt-3"
      dark
      dismissible>
      <span v-if="Array.isArray(alertMessage)">
        <span v-for="(message, idx) in alertMessage" :key="idx"> {{ message }} <br v-if="idx!==alertMessage.length"></span>
      </span>
      <span v-else>
        {{ alertMessage }}
      </span>
    </v-alert>
  </div>
</template>

<script>
// import ResetPasswordLinkModal from './ResetPasswordLinkModal'
import CookieHelper from './CookieHelper'

// const DOMAIN = 'http://localhost:8081/'
// const DOMAIN = 'https://auth-97f6c.appspot.com/'
const VERSION = process.env.VUE_APP_VERSION
const DOMAIN = process.env.VUE_APP_API_ROOT
const ORIGIN = window.location.origin.includes('accounts') ? window.location.origin.split('accounts')[1] : window.location.origin.split('auth')[1]

export default {
  name: 'Login',
  components: {
    CookieHelper
    // ResetPasswordLinkModal
  },
  data: () => ({
    username: '',
    password: '',
    triggerCookieHelper: false,
    isLoading: false,
    fullPage: true,
    alertState: false,
    isError: false,
    alertMessage: '',
    validForm: false,
    usernameRules: [
      v => !!v || 'Please enter a username'
    ],
    passwordRules: [
      v => !!v || 'Please enter a password'
    ],
  }),
  computed: {
    noRedirect: function () {
      return this.$route.query.noredirect !== undefined
    }
  },
  mounted() {
    console.log(`Version: ${VERSION}`)
    console.log(`No redirect: ${this.noRedirect}`)
    this.checkOrigin()
    this.checkAuthState()
    this.warmUpTheCoals()
    this.$refs.username.focus()
    setInterval(this.checkAuthState, 1000)
  },
  methods: {
    checkOrigin() {
      //! Cheap and nasty way to enforce everyone uses accounts domain
      if (window.location.origin.includes('auth') && !this.noRedirect) {
        const origin = window.location.origin.split('auth')[1]
        window.location = `https://accounts${origin}/login${window.location.search}`
      }
    },
    async warmUpTheCoals() {
      const url = DOMAIN + 'ae/warmup'
      const method = 'GET'
      const mode = 'no-cors'
      try {
        // const t0 = performance.now()
        await fetch(url, { method, mode })
        // console.log(`done: ${performance.now() - t0}`)
      } catch (e) {
        return console.log(e)
      }
    },
    errorCountdown(counter) {
      if (counter >= 0) {
        this.isLoading = true
        setTimeout(this.errorCountdown.bind(null, counter - 1), 1000)
      } else {
        this.alertMessage = ['This is taking longer than expected', '', 'If you are not redirected soon please let Nettex know']
        this.isError = true
        this.alertState = true
      }
    },
    blackMagic() {
      if (this.noRedirect) return
      const callback = this.$route.query.callback
      let path = this.$route.query.path || '/' // blank path if none given
      path = path.split('%26').join('&') //? Re-encode escaped ampersand
      if (path[0] !== '/') path = '/' + path
      window.location = `https://${callback}.web.app${path}`
    },
    checkAuthState() {
      //? If the cookies aren't set yet, the rest is pointless
      if (!this.$cookies.get('auth')) return
      let callback = this.$route.query.callback
      //! This will be cleaned up but adequate for now. (Edge case for nuxt site dev)
      //! Black magic... We need to perform a request to 2 domains and set cookies there
      if (callback === 'nettex' || callback === 'ordering-nettex') {
        this.triggerCookieHelper = true
        this.errorCountdown(10)
        return
      }
      //? No-redirect flag for debugging purposes (check cookies on page, force-reload, etc)
      let path = this.$route.query.path
      if (!path) path = '/' // blank path if none given
      else if (path === 'auto') path = this.determinePath()
      if (!callback) { // If a callback wasn't given we go to www on the dashboard
        callback = 'www'
        path = '/dashboard'
      }
      path = path.split('%26').join('&') //? Re-encode escaped ampersand
      if (path[0] !== '/') path = '/' + path
      if (this.noRedirect) return
      window.location = `https://${callback}${ORIGIN}${path}`
    },
    determinePath() {
      let path = '/dashboard' // default in case there's an issue
      try {
        const cookie = this.$cookies.get('auth')
        const token = JSON.parse(atob(cookie.split('.')[1]))
        const claims = token.claims
        path = claims.superAdmin || claims.admin || claims.staff || claims.agent ? '/dashboard' : '/internal/order'
      } catch (e) {
        console.log('Error determining path')
        console.log(e)
      }
      if (this.noRedirect) { // Should probably call this a debug flag then
        console.log('path is', path)
      }
      return path
    },
    async login() {
      const username = this.username.trim()
      const password = this.password.trim()
      const url = DOMAIN + 'login'
      const method = 'POST'
      const mode = 'cors'
      const credentials = 'include'
      const headers = {
        'content-type': 'application/json',
        'x-auth-cookie': document.cookie
      }
      const body = JSON.stringify({ username, password })
      this.alertState = false
      this.isError = false
      this.isLoading = true

      let response, status
      try {
        // const t0 = performance.now()
        response = await fetch(url, { method, mode, credentials, headers, body })
        // console.log(`login done: ${performance.now() - t0}`)
        status = response.status
        response = await response.json()
      } catch (e) {
        const message = 'There was an error contacting the login server. If the problem continues please contact Nettex for assistance.'
        this.alertMessage = [message, '', `"${e.message}"`]
        this.isError = true
        this.alertState = true
        return console.log(e)
      } finally {
        this.isLoading = false
        //! Setting to password to blank will trigger "incorrect password rules"
        // this.password = ''
      }
      if (status === 200) {
        //? this.$cookies.set(name, value, expiresIn, path, domain, secure)
        const serviceCookies = response.services
        for (let i = 0; i < serviceCookies.length; i++) {
          const [cName, cValue] = serviceCookies[i].split('=')
          this.setCookie(cName, cValue)
        }
        const [sessionCName, sessionCValue] = response.session.split('=')
        if (sessionCValue !== '-1') {
          this.setCookie(sessionCName, sessionCValue)
        }
        //! This needs to be set last as once the 'auth' cookie is set, checkAuthState can jump away at any time
        const [authCName, authCValue] = response.auth.split('=')
        this.setCookie(authCName, authCValue)
      } else {
        console.log(`Login failed! Status: ${status} | Error: ${response.message}`)
        this.alertMessage = `Login attempt failed, please try again.`
        this.isError = true
        this.alertState = true
      }
    },
    setCookie(cName, cValue) {
      //? Easy switch cookie setting for dev
      this.$cookies.set(cName, cValue, '1d', null, ORIGIN, true)
      // this.$cookies.set(cName, cValue, '1d', null, 'localhost', false)
    },
    async resetPassword(username) {
      const url = DOMAIN + 'createResetLink'
      const method = 'POST'
      const mode = 'cors'
      const credentials = 'include'
      const headers = {
        'content-type': 'application/json',
        'x-auth-cookie': document.cookie
      }
      const body = JSON.stringify({ username })
      this.isError = false
      this.alertState = false
      this.isLoading = true

      let response, status
      try {
        // const t0 = performance.now()
        response = await fetch(url, { method, mode, credentials, headers, body })
        // console.log(`login done: ${performance.now() - t0}`)
        status = response.status
        response = await response.json()
      } catch (e) {
        const message = 'There was an error contacting the login server. If the problem continues please contact Nettex for assistance.'
        this.alertMessage = [message, '', `"${e.message}"`]
        this.isError = true
        this.alertState = true
        return console.log(e)
      } finally {
        this.isLoading = false
      }
      if (status === 200) {
        this.alertMessage = response.message
        this.isError = !response.successful
        this.alertState = true
      } else {
        console.log(`Login failed! Status: ${status} | Error: ${response.message}`)
        this.alertMessage = response.message
        this.isError = !response.successful
        this.alertState = true
      }
    }
  }
}
</script>

<!--<style scoped>-->
<!--.link {-->
<!--  text-decoration: none;-->
<!--  border-bottom: solid 1px;-->
<!--}-->
<!--</style>-->
